import Pokemon from '../../../components/Pokemon';
import Pagination from './Pagination';

export default function PokeList(props) {
	const lastPage = () => {
		//0  - 1: -1, 0 = 0
		const lastIndex = Math.max(props.page - 1, 0);
		props.setPage(lastIndex);
	};

	const nextPage = () => {
		//0       //1  = 1
		const nextPage = Math.min(props.page + 1, props.total);
		props.setPage(nextPage);
	};

	return (
		<div>
			<div className="header">
				<h1>Pokedex</h1>
				<Pagination
					page={props.page + 1}
					totalPages={props.total}
					onLeftClick={lastPage}
					onRigthClick={nextPage}
				/>
			</div>

			{props.loading ? (
				<div>Cargando pokemones ...</div>
			) : (
				<div className="pokedex-grid">
					{props.pokemons.map((pokemon, index) => {
						return <Pokemon pokemon={pokemon} key={pokemon.name} />;
					})}
				</div>
			)}
		</div>
	);
}
